import { createContext, useContext } from "react";

import { StopListState } from "features/StopList/hooks/useStopListState";

export const StopListContext = createContext<StopListState | null>(null);

export const useStopListContext = (): StopListState => {
    const state = useContext(StopListContext);

    if (!state) {
        throw new Error("useStopListContext вызван вне StopListContext.Provider");
    }

    return state;
};
